import { render, staticRenderFns } from "./IconAddColAfter.vue?vue&type=template&id=3aed0aa7"
import script from "./IconAddColAfter.vue?vue&type=script&lang=js"
export * from "./IconAddColAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports